import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {orgId, defaultErrorHandler} from '../../../context/context';
import redirectUtils from '../../../utils/redirect-utils';
import shopifyV1Client from '../../../infrastructure/acerill/shopify-v1-client';
import uploadV1Client from '../../../infrastructure/acerill/upload-v1-client';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';
import Section from '../../../libs/react-components-admin/section/section';
import SubSection from '../../../libs/react-components-admin/section/sub-section';
import ActionButton from '../../../libs/react-components-admin/buttons/action-button';
import {TextField, EmailField} from '../../../libs/react-components-admin/fields/text-like-field';
import DeleteButton from '../../../libs/react-components-admin/buttons/delete-button';

const GoogleDriveConnectAccount = () => {

  const [loaded, setLoaded] = useState(false);
  const [accountName, setAccountName] = useState();
  const [defaultFolderName, setDefaultFolderName] = useState('acerill-forms-uploads');
  const [supportEmail, setSupportEmail] = useState();
  const [disabled, setDisabled] = useState();

  useEffect(() => {
    setDisabled(!accountName || !defaultFolderName || !supportEmail);
  }, [accountName, supportEmail]);

  useEffect(() => {
    if (!orgId.endsWith('.myshopify.com')) {
      setLoaded(true);
    } else {
      shopifyV1Client.findShopById(orgId)
        .then(({email}) => {
          setSupportEmail(email);
          setLoaded(true);
        })
        .catch(err => defaultErrorHandler(err));
    }
  }, []);

  const connectAccount = () =>
    redirectUtils.redirectTo(uploadV1Client.getGoogleDriveOauthStep1Url(accountName, defaultFolderName, supportEmail));

  if (!loaded) {
    return <CenteredSpinner/>;
  }
  return <div className="row justify-content-center">
    <div className="col-12 col-md-8">
      <TextField id="account-name"
                 label="Name"
                 helpBlock={<>Helps you identify the account</>}
                 value={accountName}
                 onChange={v => setAccountName(v)}/>
      <TextField id="default-folder-name"
                 label="Upload folder"
                 helpBlock={<>Name of the folder that will contain the uploaded files</>}
                 value={defaultFolderName}
                 onChange={v => setDefaultFolderName(v)}/>
      <EmailField id="support-email"
                  label="Support email address"
                  helpBlock={<>An alert will be sent to this email address if an issue occurs</>}
                  value={supportEmail}
                  onChange={v => setSupportEmail(v)}/>
    </div>
    <div className="w-100"/>
    <div className="col-auto">
      <ActionButton action={() => connectAccount()}
                    disabled={disabled}
                    errorHandler={defaultErrorHandler}>
        <img src={'/images/google-signin-dark-' + (disabled ? 'disabled' : 'normal') + '.png'} alt="Google signin"/>
      </ActionButton>
    </div>
  </div>;
};

const GoogleDriveAccounts = ({accounts}) => {

  const navigate = useNavigate();

  const [_accounts, setAccounts] = useState(accounts);

  const deleteAccount = id => uploadV1Client.deleteGoogleDriveAccount(id)
    .then(() => setAccounts([]));

  if (_accounts.length === 0) {
    return <GoogleDriveConnectAccount/>;
  } else {
    return <ul className="list-group">
      <li className="list-group-item">
        <div className="row align-items-center">
          <div className="col">{_accounts[0].name || ''}</div>
          <div className="col-auto">
            <ActionButton className="btn-sm btn-dark px-4"
                          action={() => new Promise(resolve => {
                            navigate(`/integrations/google-drive/accounts/${_accounts[0].id}?shop=${orgId}`);
                            resolve();
                          })}
                          errorHandler={defaultErrorHandler}>
              Edit
            </ActionButton>
          </div>
          <div className="col-auto">
            <DeleteButton action={() => deleteAccount(_accounts[0].id)}
                          errorHandler={defaultErrorHandler}/>
          </div>
        </div>
      </li>
    </ul>;
  }
};

const GoogleDrive = () => {

  const [accounts, setAccounts] = useState();

  useEffect(() => {
    uploadV1Client.findGoogleDriveAccounts()
      .then(accounts => setAccounts(accounts))
      .catch(defaultErrorHandler);
  }, []);

  return <Section title="Integration - Google Drive" noMargin={true}>
    <div className="row justify-content-center">
      <div className="col-12 col-md-8">
        <SubSection title="Connected account" className="mb-4" noMargin={true}>
          {!accounts ?
            <CenteredSpinner/> :
            <GoogleDriveAccounts accounts={accounts}/>
          }
        </SubSection>
      </div>
    </div>
  </Section>;
};

export default GoogleDrive;
